import { render, staticRenderFns } from "./BookingList.vue?vue&type=template&id=3d05220c&scoped=true&"
import script from "./BookingList.vue?vue&type=script&lang=js&"
export * from "./BookingList.vue?vue&type=script&lang=js&"
import style0 from "./BookingList.vue?vue&type=style&index=0&id=3d05220c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d05220c",
  null
  
)

export default component.exports